export default __webpack_public_path__ + "static/media/adidas-mobile-02.de66423f.jpg";